import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, TextField } from "@mui/material";

const LogFilterControls = ({ filters, onChange, fieldDefs }) => {
  return (
    <Box className="flex flex-col gap-4 overflow-y-auto p-2 flex-grow">
      {fieldDefs.map((field) => (
        <Box key={field.key} className="flex flex-col gap-1">
          <Typography variant="subtitle2">{field.label}</Typography>
          {field.type === "interval" ? (
            <Box className="flex gap-2">
              <TextField
                size="small"
                label="Min"
                type="number"
                value={filters[field.key]?.min || ""}
                onChange={(e) =>
                  onChange(field.key, {
                    ...filters[field.key],
                    min: e.target.value,
                  })
                }
              />
              <TextField
                size="small"
                label="Max"
                type="number"
                value={filters[field.key]?.max || ""}
                onChange={(e) =>
                  onChange(field.key, {
                    ...filters[field.key],
                    max: e.target.value,
                  })
                }
              />
            </Box>
          ) : (
            <TextField
              size="small"
              label="Exact Match"
              value={filters[field.key] || ""}
              onChange={(e) => onChange(field.key, e.target.value)}
            />
          )}
        </Box>
      ))}
    </Box>
  );
};

LogFilterControls.propTypes = {
  filters: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  fieldDefs: PropTypes.array.isRequired,
};

export default LogFilterControls;
